import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";

import axios from "connection";

import getDeeplinkToken from "utils/getDeeplinkToken";

import { API_URL, PPE_PATH } from "config";
import { setOffersLoaded } from "state/offers-slice";
import { setModal } from "state/config-slice";

const customBaseQuery =
  ({ baseUrl }: { baseUrl: string } = { baseUrl: "" }): BaseQueryFn =>
  async () => {
    try {
      const result = await axios.get(baseUrl, {
        headers: {
          "page-source": window.location.pathname,
        },
      });

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const offersApi = createApi({
  reducerPath: "offersApi",
  baseQuery: customBaseQuery({
    baseUrl: `${API_URL}${PPE_PATH}/offers?${getDeeplinkToken()}`,
  }),
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: () => true,
      onQueryStarted: async (_, api) => {
        const { dispatch, queryFulfilled } = api;

        try {
          const { data } = await queryFulfilled;
          if (data.redirectUrl) {
            window.location.replace(data.redirectUrl);
          } else if (data) {
            dispatch(setOffersLoaded(true));
          }
        } catch (err) {
          dispatch(
            setModal({
              showModal: true,
              errorModal: true,
            }),
          );
        }
      },
    }),
  }),
});

export const { useGetOffersQuery } = offersApi;
